import styled from 'styled-components';

export const StyledInputBase = styled.input`
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  width: 100%;
  text-align: right;
  border: none;
  background-color: inherit;

  &:disabled {
    color: rgba(0, 0, 0, 0.38);
  }
`;
